import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild, inject } from '@angular/core'
import { AdobePDFViewerComponent } from '../adobe-pdf-viewer/adobe-pdf-viewer'
import { environment } from 'src/environments/environment'
import { NgTemplateOutlet } from '@angular/common'
import { InputDialogComponent, InputDialogStepComponent } from '../input-dialog/input-dialog.component'
import { FormsModule } from '@angular/forms'
import { take } from 'rxjs'
import { Store } from '@ngrx/store'
import { BackEndService } from 'src/app/services/backend.service'
import { ToastService } from 'src/app/services/toast.service'
import { updateUserNextGenCSO } from 'src/app/state/user.actions'

@Component({
    selector: 'app-document-links',
    imports: [
        AdobePDFViewerComponent,
        NgTemplateOutlet,
        InputDialogComponent,
        InputDialogStepComponent,
        FormsModule,
    ],
    templateUrl: './document-links.component.html',
    styleUrl: './document-links.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentLinksComponent {
  private store = inject(Store<any>)
  private backendService = inject(BackEndService)
  private toastService = inject(ToastService)
  private cdr = inject(ChangeDetectorRef)


  @ViewChild(AdobePDFViewerComponent) adobePDFViewerComponent: AdobePDFViewerComponent | undefined
  @ViewChild('purchasePDF') purchasePDFComponent: InputDialogComponent = {} as InputDialogComponent
  @ViewChild('purchasePDFForm') purchasePDFForm: ElementRef = {} as ElementRef

  @Input() item: any
  @Output() purchased: EventEmitter<boolean> = new EventEmitter<boolean>()

  public pacerUsernameRequired: boolean = true
  public pacerPasswordRequired: boolean = true
  public pacerLoginButtonEnabled = true

  public pdfPurchaseIntervalTimer = 0

  public pdfPurchaseInterval = 1000
  public purchasingToken = ''
  public pacerUsername = ''
  public pacerPassword = ''
  public pacerCredentialsWrong = false


  displayPDF(cdn_path: string) {
    this.adobePDFViewerComponent!.displayPDF({
      id: 1,
      cdn_path: environment.baseUrl + cdn_path
    })
  }

  setupPacerCredentialsForm() {
    const form: HTMLFormElement = (this.purchasePDFForm.nativeElement as HTMLFormElement)
    form.classList.remove('was-validated')
    this.pacerCredentialsWrong = false
    this.pacerUsernameRequired = false
    this.pacerPasswordRequired = false
    this.pacerLoginButtonEnabled = true
  }

  checkPurchaseStatus() {
    this.backendService.checkJobStatus(this.purchasingToken).pipe(take(1)).subscribe((result: any) => {
      if (result.response.status == 'finished') {
        this.purchased.emit(true)
        this.purchasingToken = ''
        window.clearInterval(this.pdfPurchaseIntervalTimer)
      } else if (result.response.status == 'error') {
        this.purchasingToken = ''
        window.clearInterval(this.pdfPurchaseIntervalTimer)
        this.purchased.emit(false)
        this.toastService.show(result.response.result.message ?? 'An error occurred', {
          header: 'PACER Problem',
          classname: 'bg-success',
          autohide: false,
          delay: 5000,
        })
      }
    })
  }

  startPurchaseChecker() {
    this.pdfPurchaseIntervalTimer = window.setInterval(() => this.checkPurchaseStatus(), 5000)
  }

  checkPacerLogin() {
    const form: HTMLFormElement = (this.purchasePDFForm.nativeElement as HTMLFormElement)
    form.classList.add('was-validated')
    this.pacerUsernameRequired = this.pacerUsername?.length < 5
    this.pacerPasswordRequired = this.pacerPassword?.length < 5
    this.pacerCredentialsWrong = false
    this.pacerLoginButtonEnabled = false

    let problem = this.pacerUsernameRequired || this.pacerPasswordRequired
    if (!problem) {
      this.backendService.pacerLogin(this.pacerUsername, this.pacerPassword).subscribe((result) => {
        if (result.pacer.loginResult === "0") {
          this.store.dispatch(updateUserNextGenCSO(result.pacer))
          this.purchasePDFComponent.advanceToNextStep()
          this.startDocumentPurchaseJob(result.pacer.nextGenCSO, this.item)
        } else {
          this.pacerCredentialsWrong = true
          this.pacerLoginButtonEnabled = true
          this.cdr.detectChanges()
        }
      })
    }
    this.pacerLoginButtonEnabled = problem
    return problem
  }

  startDocumentPurchaseJob(nextGenCSO: string, document: Document) {
    this.backendService.startDocumentProcess({
      request: {
        nextGenCSO: nextGenCSO,
        document,
        creds: [this.pacerUsername, this.pacerPassword]
      }
    }).subscribe((result) => {
      this.purchasingToken = result.token
      this.startPurchaseChecker()
      this.cdr.detectChanges()
    })
  }

  purchaseDocument() {
    this.setupPacerCredentialsForm()
    this.purchasePDFComponent.showModal()
  }
}
